// 배경 장식 — 소수의 별이 크기를 달리하며 은은하게 글로우·반짝임. 과하지 않게 소수만.
const STARS: { top: string; left: string; size: number; delay: number; duration: number; blue?: boolean }[] = [
  { top: "8%", left: "16%", size: 2, delay: 0, duration: 3.2 },
  { top: "14%", left: "82%", size: 3, delay: 0.6, duration: 2.6, blue: true },
  { top: "34%", left: "6%", size: 2, delay: 1.1, duration: 3.6 },
  { top: "52%", left: "90%", size: 4, delay: 0.3, duration: 3, blue: true },
  { top: "71%", left: "22%", size: 3, delay: 1.6, duration: 2.8 },
  { top: "86%", left: "70%", size: 2, delay: 0.9, duration: 3.4 },
];

export function TwinkleStars() {
  return (
    <>
      {STARS.map((s, i) => {
        const color = s.blue ? "var(--accent-bright)" : "var(--gold-bright)";
        return (
          <span
            key={i}
            style={{
              position: "absolute",
              top: s.top,
              left: s.left,
              width: s.size,
              height: s.size,
              borderRadius: "50%",
              background: color,
              boxShadow: `0 0 ${s.size * 2.5}px ${s.size * 0.6}px ${s.blue ? "rgba(110,136,163,0.55)" : "rgba(247,248,250,0.45)"}`,
              animation: `om-twinkle ${s.duration}s ${s.delay}s ease-in-out infinite`,
              pointerEvents: "none",
              zIndex: 0,
            }}
          />
        );
      })}
    </>
  );
}
